// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanCategorySpendLimitDto
 */
export interface IPlanCategorySpendLimitDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanCategorySpendLimitDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanCategorySpendLimitDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanCategorySpendLimitDto
     */
    health_plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanCategorySpendLimitDto
     */
    coverage_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanCategorySpendLimitDto
     */
    category_type?: IPlanCategorySpendLimitDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanCategorySpendLimitDto
     */
    category_spend_limit?: number;
}

/**
* @export
* @enum {string}
*/
export enum IPlanCategorySpendLimitDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IPlanCategorySpendLimitDto interface.
 */
export function instanceOfIPlanCategorySpendLimitDto(value: object): value is IPlanCategorySpendLimitDto {
    return true;
}

export function IPlanCategorySpendLimitDtoFromJSON(json: any): IPlanCategorySpendLimitDto {
    return IPlanCategorySpendLimitDtoFromJSONTyped(json, false);
}

export function IPlanCategorySpendLimitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanCategorySpendLimitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'health_plan_id': json['health_plan_id'] == null ? undefined : json['health_plan_id'],
        'coverage_id': json['coverage_id'] == null ? undefined : json['coverage_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'category_spend_limit': json['category_spend_limit'] == null ? undefined : json['category_spend_limit'],
    };
}

export function IPlanCategorySpendLimitDtoToJSON(json: any): IPlanCategorySpendLimitDto {
    return IPlanCategorySpendLimitDtoToJSONTyped(json, false);
}

export function IPlanCategorySpendLimitDtoToJSONTyped(value?: IPlanCategorySpendLimitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_id': value['plan_id'],
        'health_plan_id': value['health_plan_id'],
        'coverage_id': value['coverage_id'],
        'category_type': value['category_type'],
        'category_spend_limit': value['category_spend_limit'],
    };
}

